document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[data-product-id]').forEach(function(button) {
      button.addEventListener('click', function() {
          const productId = this.getAttribute('data-product-id');
          const selectElement = document.querySelector(`select[data-variant-id="${productId}"]`);
          const variantId = selectElement.value;
          adicionarAoCarrinho(variantId);
      });
  });
});


function adicionarAoCarrinho(produtoId) {
  var dados = {
    items: [{
      id: produtoId,
      quantity: 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dados)
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      console.error('Erro ao adicionar o produto ao carrinho');
    }
  })
  .then(cart =>{
    Shopify.onCartUpdate(cart);
  
  })
  .catch(error => {
    console.error('Erro:', error);
  });
}


